import {
  LayoutDashboard, Users, FolderOpen, Palmtree, Clock, CalendarDays, Wallet, Receipt,
  Target, Star, GraduationCap, Search as SearchIcon, Megaphone, MessageSquare, ClipboardList,
  CheckSquare, DoorOpen, UserPlus, LifeBuoy, Laptop, Plane, BarChart3, Shield, CircleDollarSign, Network, UserCircle,
  Inbox, Workflow, Settings as SettingsIcon, BadgeCheck, Mail, Award, Activity, Timer, TrendingUp,
  Coffee, ShieldCheck, MessageSquareHeart, SlidersHorizontal, IdCard,
  HeartHandshake, Landmark, ListPlus, Milestone, ShieldAlert, Car,
} from "lucide-react";

// done:true => implemented page; else Phase 2 placeholder
export const NAV = [
  { group: "Personal", items: [
    { to: "/me", label: "My Space", icon: UserCircle, done: true },
    { to: "/my-profile", label: "My Profile", icon: IdCard, done: true },
    { to: "/approvals", label: "Approvals", icon: Inbox, done: true },
    { to: "/policies", label: "Policies", icon: ShieldCheck, done: true },
  ]},
  { group: "Core HR", items: [
    { to: "/", label: "Dashboard", icon: LayoutDashboard, done: true, exact: true },
    { to: "/employees", label: "Employees", icon: Users, done: true },
    { to: "/orgchart", label: "Org Chart", icon: Network, done: true },
    { to: "/documents", label: "Documents", icon: FolderOpen, done: true },
  ]},
  { group: "Time", items: [
    { to: "/leave", label: "Leave", icon: Palmtree, done: true },
    { to: "/attendance", label: "Attendance", icon: Clock, done: true },
    { to: "/timesheets", label: "Timesheets", icon: Timer, done: true },
    { to: "/compoff", label: "Comp-off", icon: Coffee, done: true },
    { to: "/calendar", label: "Calendar", icon: CalendarDays, done: true },
    { to: "/holidays", label: "Holidays", icon: CalendarDays, done: true },
  ]},
  { group: "Finance", items: [
    { to: "/payroll", label: "Payroll", icon: Wallet, done: true },
    { to: "/expenses", label: "Expenses", icon: Receipt, done: true },
    { to: "/loans", label: "Loans & Bonuses", icon: CircleDollarSign, done: true },
    { to: "/benefits", label: "Benefits & Advances", icon: HeartHandshake, done: true },
    { to: "/tax", label: "Tax Center", icon: Landmark, done: true },
    { to: "/pay-inputs", label: "Pay Inputs", icon: ListPlus, done: true, roles: ["SUPERADMIN", "HR_ADMIN"] },
    { to: "/compensation", label: "Compensation", icon: TrendingUp, done: true, roles: ["SUPERADMIN", "HR_ADMIN"] },
  ]},
  { group: "Growth", items: [
    { to: "/performance", label: "Performance", icon: Target, done: true },
    { to: "/feedback", label: "360° Feedback", icon: MessageSquareHeart, done: true },
    { to: "/talent", label: "Talent Hub", icon: Star, done: true },
    { to: "/learning", label: "Learning", icon: GraduationCap, done: true },
    { to: "/recruitment", label: "Recruitment", icon: SearchIcon, done: true },
    { to: "/requisitions", label: "Requisitions", icon: ClipboardList, done: true, roles: ["SUPERADMIN", "HR_ADMIN", "MANAGER"] },
  ]},
  { group: "Connect", items: [
    { to: "/announcements", label: "Announcements", icon: Megaphone, done: true },
    { to: "/vibe", label: "Vibe", icon: MessageSquare, done: true },
    { to: "/recognition", label: "Recognition", icon: Award, done: true },
    { to: "/pulse", label: "Pulse", icon: Activity, done: true },
    { to: "/surveys", label: "Surveys", icon: ClipboardList, done: true },
    { to: "/tasks", label: "Tasks", icon: CheckSquare, done: true },
  ]},
  { group: "Operations", items: [
    { to: "/exit", label: "Exit Mgmt", icon: DoorOpen, done: true },
    { to: "/onboarding", label: "Onboarding", icon: UserPlus, done: true },
    { to: "/lifecycle", label: "Promotions & Transfers", icon: Milestone, done: true },
    { to: "/grievances", label: "Grievances", icon: ShieldAlert, done: true },
    { to: "/confirmation", label: "Confirmation", icon: BadgeCheck, done: true, roles: ["SUPERADMIN", "HR_ADMIN", "MANAGER"] },
    { to: "/helpdesk", label: "Help Desk", icon: LifeBuoy, done: true },
    { to: "/assets", label: "Assets", icon: Laptop, done: true },
    { to: "/fleet", label: "Fleet", icon: Car, done: true },
    { to: "/travel", label: "Travel", icon: Plane, done: true },
  ]},
  { group: "Insights", items: [
    { to: "/reports", label: "Reports", icon: BarChart3, done: true },
    { to: "/email-outbox", label: "Email Outbox", icon: Mail, done: true, roles: ["SUPERADMIN", "HR_ADMIN"] },
    { to: "/flows", label: "Flow Manager", icon: Workflow, done: true, roles: ["SUPERADMIN", "HR_ADMIN"] },
    { to: "/settings", label: "Settings", icon: SettingsIcon, done: true, roles: ["SUPERADMIN", "HR_ADMIN"] },
    { to: "/custom-fields", label: "Custom Fields", icon: SlidersHorizontal, done: true, roles: ["SUPERADMIN", "HR_ADMIN"] },
    { to: "/admin", label: "Administration", icon: Shield, done: true, roles: ["SUPERADMIN"] },
  ]},
];
